<template>
    <div>
        <UtilsContent @close-action="closeNotes">
            <template v-slot:header>
                <div class="d-flex flex-row justify-start align-center mx-3 mb-4">
                    <img :src="indexImg" class="img-index mr-2" alt="" />
                    <span class="text-h5 ma-0 primary--text">
                        {{ $t('bookReading.notes') }}
                    </span>
                </div>
            </template>
            <template v-slot:content>
                <div class="mx-3">
                    <div class="d-flex flex-column">
                        <v-checkbox
                            data-cy="stickyNotes-show-all-notes-button"
                            v-model="bookReadConf.showNotes"
                            :label="$t('bookReading.showAllNotes')"
                        />
                    </div>
                    <div
                        class="d-flex flex-column chapters-container"
                        id="chapter-container"
                        v-if="bookUserNotes.length"
                    >
                        <NoteItem
                            data-cy="stickyNotes-note-item"
                            v-for="(note, index) of bookUserNotes"
                            :key="index"
                            :note_data="note"
                        />
                    </div>
                    <div class=" d-flex flex-column chapters-container" v-else>
                        <span class="text-h6 text-center">
                            {{ $t('bookReading.without_notes') }}
                        </span>
                    </div>
                </div>
            </template>
            <template v-slot:actions>
                <v-btn
                    color="#95afad"
                    fab
                    small
                    dark
                    class="mt-5 text--white"
                    @click="downScroll"
                    v-if="bookUserNotes.length"
                >
                    <v-icon dark class="text--white">mdi-arrow-down</v-icon>
                </v-btn>
            </template>
        </UtilsContent>
    </div>
</template>
<script>
/* eslint-disable global-require */
import { mapState } from 'vuex'

import UtilsContent from '@/components/core/utils/UtilsContent.vue'
import NoteItem from './items/NoteItem.vue'

export default {
    components: {
        UtilsContent,
        NoteItem,
    },
    computed: {
        ...mapState({
            bookUserNotes: (state) => state.bookReading.bookUserNotes,
            currentChapter: (state) => state.bookReading.currentChapter,
            bookReadConf: (state) => state.bookReading.bookReadConf,
        }),
    },
    data() {
        return {
            indexImg: require('@/assets/img/icons/reading/icon-notes-2.svg'),
        }
    },
    methods: {
        downScroll() {
            const el = document.getElementById('chapter-container')
            el.scrollTop += 10
        },
        closeNotes() {
            this.$emit('close-note')
        },
    },
}
</script>
<style>
.chapters-container {
    height: 35vh;
    max-height: 35vh;
    overflow: auto;
}
</style>
